import * as api from "../api";
import { FETCHTOTALINCOME } from "../constants/actionTypes";

export const getTotalIncome = (storeId) => async (dispatch) => {
  try {
    const { data } = await api.getTotalIncome(storeId);
    dispatch({ type: FETCHTOTALINCOME, payload: data.totalsales });
  } catch (error) {
    console.log(error);
  }
};
